

const Banner = () =>{
    return(
        <section id="banner"></section>
    );
}

export default Banner;